// import { resolve } from "url";
import * as webauthnJson from "../webauthn/webauthn-json.js";

//"use strict";

//declare var grecaptcha: any;
declare var $: any;
declare var _serverUrl: string;

//declare var _shouldSolveCaptcha: any;



let _cardID;
let certificate;
let keypairid;
let subject;
let challenge;
let signature;
let hash;
let padding;
var credentialID;

declare var _siteSettings: any;
declare function X509(): void;
declare function zulutodate(zuluDate: any): any;

const agentURL = 'https://127.0.0.1:8440/api/v1/pki';

export default class Ajax {

  static InitiateLoginSequence() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          option: "credential",
          initiateLoginSequence: true,
          isAjax: "true"
        },
        success: function (data: any) {
            resolve(data);
        },
        error: function (err: any) {
          reject("N_General_Error_SYSTEM_ERROR")
        }
      })
    });
  }

  static FirstLoginSMS(id: string, password: string) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          option: "credential",
          Ecom_Password: password,
          Ecom_User_ID: id,
          isAjax: "true"         
        },
        success: function (data: any) {
          // if (data.isCaptchaNeeded != undefined) {
          //   _shouldSolveCaptcha = data.isCaptchaNeeded ;
          // }
          if (data.isError) {
            reject(data);            
          } else {
            resolve(data);
          }
        },
        error: function (err: any) {
          reject();
        }
      })
    });
  }

  static SendOtpToMail(){
    return new Promise((resolve, reject) => {

      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          option: "credential",
          sendToEmail: true,
          isAjax: "true"
        },
        success: function (data: any) {
          if (data.isError) {
            reject("N_General_Error_" + data.errorCode);            
          } else {
            resolve(data);
          }
        },
        error: function (err: any) {
          reject();
        }
      })
    });
  }

  static SecondLoginSMS(otp: string) {

    return new Promise((resolve, reject) => {

      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          option: "credential",
          otp: otp,
          isAjax: "true"
        },
        success: function (data: any) {
          if (data.isError) {
            reject("N_General_Error_" + data.errorCode);            
          } else {
            resolve(data);
          }
        },
        error: function (err: any) {
          reject();
        }
      })
    });
  }

   static CheckUnibeamStatus() {

    return new Promise((resolve, reject) => {

      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          option: "credential",
          op: "checkStatus",  
          isAjax: "true"
        },
        success: function (data: any) {
          if (data.isError) {
            reject(data);            
          } else {
            resolve(data);
          }
        },
        error: function (err: any) {
          reject();
        }
      })
    });
  }

   static CheckUnibeamStatusDemo() {

    return new Promise((resolve, reject) => {

      const data:any = {
        "isError": true,
        "errorCode": "ERROR_UB_AUTH_FAILED_FALLBACK_SMS",
        "otpDestMasked": "UB2:xxxxxxxxxxx9961",
        "maskedEmail": "d****e@d******.gov.il"
      }

      if (data.isError) {
        reject(data);            
      } else {
        resolve(data);
      }  

    });
  }

  static PreRegCheck(id: string, email:string, mobile:string) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          option: "credential",          
          isAjax: "true",
          idNum: id,
          mobile: mobile,
          email: email         
        },
        success: function (data: any) {         
          if (!data.isError) {
            resolve(data);
          } else {
            reject(data);
          }
        },
        error: function (err: any) {
          reject("N_General_Error_SYSTEM_ERROR")
        }
      })
    });
  }

  static PreRegCheckDemo(id: string, email:string, mobile:string, captchaResponse: string) {
    return new Promise((resolve, reject) => {      
      $.ajax({
        type: 'GET',
        url: 'http://localhost:3004/preRegResponseError2',
        contentType: 'Application/Json',
        success: function(data: any){ 
          if (!data.isError) {
            resolve(data);
          } else {
            reject(data);
          }
        },
        error: function () {
          reject();
        }
      });
    });
  }

  static CheckInstalled() {
    return new Promise<void>((resolve, reject) => {
      $.ajax({
        type: 'GET',
        cache: false,
        url: `${agentURL}/getreaderon?nowait`,
        success: function (data: any) {
          resolve();
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }


  static CheckAgent() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        cache: false,
        url: `${agentURL}/getreaderon?nowait`,
        success: function (data: any) {
          if (data.result === "READER_ON") {
            resolve(data);
          }
          else {
            reject();
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }


  static CheckCard() {
    return new Promise<void>((resolve, reject) => {
      $.ajax({
        type: 'GET',
        cache: false,
        url: `${agentURL}/getmessage?nowait`,
        success: function (data: any) {
          if (data.result ==="CARD_ON") {
            _cardID = data.cardid
            resolve();
          }
          else {
            reject();
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }


  static CheckRemovedCard() {
    return new Promise<void>((resolve, reject) => {
      $.ajax({
        type: 'GET',
        cache: false,
        url: `${agentURL}/getcardoff?wait`,
        success: function (data: any) {
          if (data.result !== "CARD_ON") {
            resolve();
          }
          else {
            reject();
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }


  static CheckReaderOff() {
    return new Promise<void>((resolve, reject) => {
      $.ajax({
        type: 'GET',
        cache: false,
        url: `${agentURL}/getcardon?nowait`,
        success: function (data: any) {
          if (data.result ==="NO_READER") {
            resolve();
          }
          else {
            reject();
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }


  static ExtractDetails(certificate: string) {

    return new Promise((resolve, reject) => {
      var x509Obj = new X509();
      x509Obj.readCertHex(certificate);
      var issuer = x509Obj.getIssuerString();
      const details = x509Obj.getExtSubjectAltName2();
      let firstName, lastName,userId, issuerName;
      const subjectString = x509Obj.getSubjectString();
      const expiredDate = zulutodate(x509Obj.getNotAfter());
      const startDate = zulutodate(x509Obj.getNotBefore());
      const now = new Date();

      if (expiredDate <= now) {
        reject('N_General_Error_SmartCard_Card_Expired')        
      }
      if (startDate > now) {
        reject('N_General_Error_INVALID_X509_CERT_NOT_YET_VALID')        
      }

      switch (issuer) {
        case _siteSettings.validIssuers.ISRAEL_EID_ISSUERS:
          for (const item of details) {
            if (item[0] === 'GIVENNAME')
              firstName = item[1]
            if (item[0] === 'SN')
              lastName = item[1]
          }
          let data = subjectString.slice(subjectString.indexOf('serialNumber') + ('serialNumber').length + 1)
          userId = data.slice(0, data.indexOf('/CN'))
          resolve({ userId, firstName, lastName })
          break;
        case _siteSettings.validIssuers.TAMUZ_CARD_ISSUERS:
        case _siteSettings.validIssuers.TAMUZ_CARD_ISSUERSV3:
          var cn = subjectString.split('/CN=')[1];
          var splitCN = cn.split(" ");
          firstName = ''; // splitCN[0].toUpperCase();
          lastName = ''; // splitCN[1].toUpperCase();
          userId = splitCN[2].replace("ID_","").trim();
          issuerName = issuer;
          resolve({userId, firstName, lastName, issuerName})
          break;
        case _siteSettings.validIssuers.COMSIGN_CARD_ISSUERS:
        case _siteSettings.validIssuers.COMSIGN_CARD_ISSUERS2:
        case _siteSettings.validIssuers.PERSONALID_CARD_ISSUERS:
          //console.log('switch case');         
          var cn = subjectString.split('/CN=')[1];
          var splitCN = cn.split(" ");
          firstName = ''; // splitCN[0].toUpperCase();
          lastName = ''; // splitCN[1].toUpperCase();
          userId = splitCN[2].replace("ID_","").trim();
          issuerName = issuer;
          resolve({userId, firstName, lastName, issuerName})
          break;
        default:               
          reject('N_General_Error_INVALID_X509_CERT_PATH');
          break;
      }
    })
  }


  static GetCardCertificate() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        cache: false,
        url: `${agentURL}/getcertificates?nowait`,
        success: (data: any) => {
          if (data.certificates !== undefined) {
            if (data.certificates.length == 0){
              reject('N_General_Error_SYSTEM_ERROR');
            }
            // if (data.certificates.length > 0 && checkIssuer ){
            //   var certificate = data.certificates[0].certificate;
            //   var x509Obj = new X509();
            //   x509Obj.readCertHex(certificate);    
            //   var issuer = x509Obj.getIssuerString();
              
            //   if(issuer === _siteSettings.validIssuers.COMSIGN_CARD_ISSUERS || 
            //       issuer === _siteSettings.validIssuers.COMSIGN_CARD_ISSUERS2 || 
            //       issuer === _siteSettings.validIssuers.PERSONALID_CARD_ISSUERS){
            //         reject('SmartCard_Not_Allowed');
            //   }                                                

            // }

            if (data.certificates.length > 1)
            {              
                var expired:boolean = false;
                var notYetValid:boolean =false;
                var validCertificate:any = null;
                            
              data.certificates.forEach(c => {
                var x509Obj = new X509();
                x509Obj.readCertHex(c.certificate);    
                var issuer = x509Obj.getIssuerString();            
                const expiredDate = zulutodate(x509Obj.getNotAfter());
                const startDate = zulutodate(x509Obj.getNotBefore());
                const now = new Date();

                if (expiredDate <= now) {                 
                  expired = true;
                }
                else if (startDate > now) {                  
                  notYetValid = true; 
                } 
                else if(issuer === _siteSettings.validIssuers.ISRAEL_EID_ISSUERS ||
                        issuer === _siteSettings.validIssuers.TAMUZ_CARD_ISSUERS || 
                        issuer === _siteSettings.validIssuers.TAMUZ_CARD_ISSUERSV3 || 
                        issuer === _siteSettings.validIssuers.COMSIGN_CARD_ISSUERS || 
                        issuer === _siteSettings.validIssuers.COMSIGN_CARD_ISSUERS2 || 
                        issuer === _siteSettings.validIssuers.PERSONALID_CARD_ISSUERS){
                  validCertificate = c;
                }                                                
              }); 

              if(validCertificate != null){
                certificate = validCertificate.certificate;
                subject = validCertificate.subject;
                keypairid = validCertificate.keypairid;
                this.ExtractDetails(certificate)
                  .then(data => resolve(data))
                  .catch(error => reject(error))  
              }
              else if(expired){
                reject('N_General_Error_SmartCard_Card_Expired');
              }
              else if(notYetValid){
                reject('N_General_Error_INVALID_X509_CERT_NOT_YET_VALID');
              }
              else{
                reject('INVALID_X509_CERT');
              }    
            }
            else
            {
              certificate = data.certificates[0].certificate;
              subject = data.certificates[0].subject;
              keypairid = data.certificates[0].keypairid;
              this.ExtractDetails(certificate)
                .then(data => resolve(data))
                .catch(error => reject(error))  
            }
          }
          else {
            if(data.result === 'NO_CARD')
              reject('N_General_Error_CARD_REMOVED_ERRO_1');
            else
              reject('N_General_Error_SYSTEM_ERROR');
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }



  static GetChallangeFromServer() {
    return new Promise<void>((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: _serverUrl,
        cache: false,
        data: {
          cardUID: _cardID,
          certificate,          
          isAjax: "true",
          option: 'credential'
        },
        success: function (data: any) {
          if (data.isError === false) {
            challenge = data.challenge;
            resolve();
          } else {
            reject("N_General_Error_" +data.errorCode);
          }
        },
        error: function (err: any) {
          reject();
        }
      })

    });

  }


  static SignChallange(pin: string) {
    return new Promise<void>((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: `${agentURL}/signchallenge`,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        cache: false,
        data: JSON.stringify({
          challenge,
          keypairid,
          pin,
          subject
        }),
        success: function (data: any) {
          if (data.result && (data.result ==="WRONG_PIN" || data.result ==='OPERATION_FAILED')) {
            reject('N_General_Error_ID_PIN');
          }
          if (data.result && data.result ==="CKR_PIN_LOCKED") {
            reject('N_General_Error_PIN_LOCKED');
          }
          if (!data.signature) {
            reject('N_General_Error_SYSTEM_ERROR')
          }
          else {
            hash = data.hash;
            padding = data.padding;
            signature = data.signature;
            resolve();
          }
        },

        error: function (err: any) {
          reject()
        }
      })
    })
  }

  static SignDummyChallange(pin: string) {
    const challenge = '1111111111111111111111111111111111111111111111111111111111111111';
    return new Promise<void>((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: `${agentURL}/signchallenge`,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        cache: false,
        data: JSON.stringify({
          challenge,
          keypairid,
          pin,
          subject
        }),
        success: function (data: any) {
          if (data.result && (data.result ==="WRONG_PIN" || data.result ==='OPERATION_FAILED')) {
            reject('N_General_Error_ID_PIN');
          }
          if (data.result && data.result ==="CKR_PIN_LOCKED") {
            reject('N_General_Error_PIN_LOCKED');
          }
          if (!data.signature) {
            reject('N_General_Error_SYSTEM_ERROR')
          }
          else {
            hash = data.hash;
            padding = data.padding;
            signature = data.signature;
            resolve();
          }
        },

        error: function (err: any) {
          reject()
        }
      })
    })
  }

  static SendSigServer() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: _serverUrl,
        cache: false,
        data: {
          hash,
          isAjax: "true",
          option: 'credential',
          padding,
          signature
        },
        success: function (data: any) {
          if (data.isError === false) {
            resolve(data);
          } else {
            if (data.errorCode === 'FAILED_PKI_LOGON_EXPIRED')
              reject('N_General_Error_LOGIN_EXPIRED');
            else
              reject("N_General_Error_" + data.errorCode);
          }
        },
        error: function (err: any) {
          reject()
        }
      })

    });
  }


  static ApplicationLogin(userId: string, email: string, phone: string,captchaResponse: string) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: _serverUrl,
        cache: false,
        data: {
          "g-recaptcha-response": captchaResponse,
          GOV_ID: userId,
          GOV_MOBILE: phone,
          GOV_EMAIL: email,
          isAjax: true,
          option: 'credential'
        },
        success: function (data: any) {
          //_shouldSolveCaptcha = data.isCaptchaNeeded;
          if (data.isError === false) {
            resolve(data);
          } else {
            reject("N_General_Error_" + data.errorCode);
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }


  static ApplicationLoginStatus() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          isAjax: true,
          option: 'credential'
        },
        success: function (data: any) {
          if (data.isError === false) {
            resolve(data);
          } else {
            reject("N_General_Error_" + data.errorCode);
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }


  static onPKILoginEnd() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          isAjax: true,
          option: 'credential'
        },
        success: function (data: any) {
          if (data.isError) {
            reject("N_General_Error_" + data.errorCode);            
          } else {
            resolve(data);
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }

  static onPKILoginEndPK() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          isAjax: true,
          option: 'credential',
          op:'continue'
        },
        success: function (data: any) {
          if (data.isError) {
            reject("N_General_Error_" + data.errorCode);            
          } else {
            resolve(data);
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }


  static sendContactAgreement(isUserAgree:boolean) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          isAjax: true,
          option: 'credential',
          agreeToShareMobile: isUserAgree,
          agreeToShareEmail: isUserAgree
        },
        success: function (data: any) {
          if (data.isError) {
            reject("N_General_Error_" + data.errorCode);            
          } else {
            resolve(data);
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }




  static SendUserMail(mail:string) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          isAjax: true,
          option: 'credential',
          email:mail
        },
        success: function (data: any) {
          if (data.isError === false) {
            resolve(data);
          } else {
            reject("N_General_Error_" + data.errorCode);
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }

  static SendUserMailOtp(mailOtp:string) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          isAjax: true,
          option: 'credential',
          otp: mailOtp
        },
        success: function (data: any) {
          if (data.isError === false) {
            resolve(data);
          } else {
            reject("N_General_Error_" + data.errorCode);
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }

  static continueRequest() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          isAjax: true,
          option: 'credential',
          op:'continue'
        },
        success: function (data: any) {
          if (data.isError) {
            reject("N_General_Error_" + data.errorCode);            
          } else {
            resolve(data);
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }

  static SendUserPhone(phone:string, messageType:string) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          isAjax: true,
          option: 'credential',
          mobile: phone,
          messageType: messageType
        },
        success: function (data: any) {
          if (data.isError === false) {
            resolve(data);
          } else {
            reject("N_General_Error_" + data.errorCode);
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }

  
  static SendUserPhoneOtp(phoneOtp:string) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          isAjax: true,
          option: 'credential',
          otp: phoneOtp
        },
        success: function (data: any) {
          if (data.isError === false) {
            resolve(data);
          } else {
            reject("N_General_Error_" + data.errorCode);
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }


  static ResendPhoneOtp(messageType:string) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          isAjax: true,
          option: 'credential',
          resend: 'sms',
          messageType: messageType
        },
        success: function (data: any) {
          if (data.isError === false) {
            resolve(data);
          } else {
            reject("N_General_Error_" + data.errorCode);
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }


  static SendPassword(password) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          isAjax: true,
          option: 'credential',
          password: password
        },
        success: function (data: any) {
          if (data.isError === false) {
            resolve(data);
          } else {
            reject("N_General_Error_" + data.errorCode);
          }
        },
        error: function (err: any) {
          reject()
        }
      })
    })
  }


  static ResetUserStatus() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          isAjax: true,
          option: 'credential',
          reset: true
        },
        success: function () {
          resolve(null);                     
        },
        error: function () {
          reject();
        }
      })
    })
  }

    
  static CheckEnrolledPasskeys(){
    return new Promise((resolve, reject) => {

      $.ajax({
        type: 'POST',
        cache: false,
        url: _serverUrl,
        data: {
          option: "credential",         
          isAjax: "true",
          op: "checkEnrolledPasskeys"
        },
        success: function (data: any) {
          if (data.isError) {
            reject("N_General_Error_" + data.errorCode);            
          } else {
            resolve(data);
          }
        },
        error: function (err: any) {
          reject();
        }
      })
    });
  }


  static setAuthenticatorNickname(nickname){
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: _serverUrl,
        data: {
          option: "credential",
          isAjax: "true",
          op: "setPasskeyNickName",
          nickname: nickname
        },
        success: function(data){ 
          if (!data.isError){	
            resolve(data.credentialID);
          }else{
            reject("N_General_Error_" + data.errorCode); 
          }
        },
        error: function () {
          reject();
        }
      });
    });
  }


  static sendRegistrationRequest(publicKeyCredential){
    return new Promise((resolve, reject) => {
    
      $.ajax({
        type: 'POST',
        url: _serverUrl,
        data: {
          option: "credential",
          isAjax: "true",
          op: "registerPasskey",
          registrationData: btoa(JSON.stringify(publicKeyCredential))
        },
        success: function(data){ 
          if (!data.isError){	           
            resolve(data.credentialID);
          }else{
            reject("N_General_Error_" + data.errorCode);                
          }
        },
        error: function () {
          reject();
        }
      });
    });
  }


  static sendAuthPk(publicKeyCredential){
    return new Promise((resolve, reject) => {    
      $.ajax({
        type: 'POST',
        url: _serverUrl,
        data: {
          option: "credential",
          isAjax: "true",
          op: "doAuthentication",
          publicKeyCredentialJson: btoa(JSON.stringify(publicKeyCredential))
        },
        success: function(verifyAuthResponse){ 
          if (!verifyAuthResponse.isError){	           
            resolve(verifyAuthResponse);
          }else{
            reject("N_General_Error_" + verifyAuthResponse.errorCode);                
          }
        },
        error: function () {
          reject();
        }
      });
    });
  }

  
  // Passkey demo static functions - start
  static setAuthenticatorNicknameDemo(nickname){
    return new Promise((resolve, reject) => {
    
      $.ajax({
        type: 'GET',
        url: 'http://localhost:3002/regResponse',
        contentType: 'Application/Json',
        success: function(data){ 
          if (!data.isError){	            
            resolve(data.credentialID);
          }else{
            reject("N_General_Error_" + data.errorCode);               
          }
        },
        error: function () {
          reject();
        }
      });
    });
  }


  static sendRegistrationRequestDemo(publicKeyCredential){
    return new Promise((resolve, reject) => {
    
      $.ajax({
        type: 'GET',
        url: 'http://localhost:3002/regResponse',
        contentType: 'Application/Json',
        success: function(data){ 
          if (!data.isError){	           
            resolve(data.credentialID);
          }else{
            reject("N_General_Error_" + data.errorCode);               
          }
        },
        error: function () {
          reject();
        }
      });
    });
  }


  static sendAuthPkDemo(publicKeyCredential){
    return new Promise((resolve, reject) => {
    
      $.ajax({
        type: 'GET',
        url: 'http://localhost:3002/regResponse',
        contentType: 'Application/Json',
        success: function(data){ 
          if (!data.isError){	           
            resolve(data.credentialID);
          }else{
            reject("N_General_Error_" + data.errorCode);               
          }
        },
        error: function () {
          reject();
        }
      });
    });
  }

  // Passkey demo static functions - end
    
}


//*** async functions */ 
export async function startRegistrationProcess(){
  return new Promise((resolve, reject) => {
    $.ajax({
      type: 'POST',        
      cache: false,
      url: _serverUrl,
      data: {
        option: "credential",         
        isAjax: "true",
        op: "generatePasskeyRegistrationData"
      },
      success: async function (data: any) {
        if (data.isError) {
          reject("N_General_Error_" + data.errorCode);            
        } else {
            const credentialCreateOptions = JSON.parse(data.webAuthnParams);	
            let publicKeyCredential;					                
            try{
              publicKeyCredential = await webauthnJson.create(credentialCreateOptions);
              resolve(publicKeyCredential);
            }catch(e){
              if(publicKeyCredential === undefined) {
                reject('cancel');
              }
              else{
                reject();
              }                    
            }
        }
      },
      error: function (err: any) {
        reject();
      }
    });
  });
}

export async function doAuth(){
  return new Promise((resolve, reject) => {
    $.ajax({
      type: 'POST',        
      cache: false,
      url: _serverUrl,
      data: {
        option: "credential",         
        isAjax: "true",
        op: "getAuthParams"
      },
      success: async function (authGetParamsResponse: any) {
        if (!authGetParamsResponse.isError){
          const credentialGetOptions = JSON.parse(authGetParamsResponse.webAuthnParams);	
          let publicKeyCredential;			                      
          try{
            publicKeyCredential = await webauthnJson.get(credentialGetOptions);
            if(publicKeyCredential.response.userHandle === null){
              reject();
            }
            else{
               resolve(publicKeyCredential);                
            }               
          }catch(e){           
            if(publicKeyCredential === undefined) {
              reject('cancel');
            }
            else{
              reject();
            }    
          }
        }
        else{
          reject("N_General_Error_" + authGetParamsResponse.errorCode); 
        }        
      },
      error: function (err: any) {
        reject(err);
      }
    });
  });
}

// Passkey demo async functions - start
export async function startRegistrationProcessDemo(){	  
  return new Promise((resolve, reject) => {
    $.ajax({
      type: 'GET',      
      url: 'http://localhost:3001/publicKey',
      contentType: 'Application/Json',
      success: async function (data) {				
        if (!data.isError){
          let publicKeyCredential;			
          const credentialCreateOptions = JSON.parse(data.webAuthnParams);					                      
          try{
            publicKeyCredential = await webauthnJson.create(credentialCreateOptions);
            resolve(publicKeyCredential);            
          }catch(e){           
            if(publicKeyCredential === undefined) {
              reject('cancel');
            }
            else{
              reject();
            }  
          }
        }
      },
      error: function () {
        reject();
      }
    });		
  });   
}

export async function doAuthDemo(){
  return new Promise((resolve, reject) => {
    $.ajax({
      type: 'GET',      
      url: 'http://localhost:3003/authParamsResponse',
      contentType: 'Application/Json',
      success: async function (authGetParamsResponse) {				
        if (!authGetParamsResponse.isError){
          const credentialGetOptions = JSON.parse(authGetParamsResponse.webAuthnParams);
          let publicKeyCredential;				                      
          try{
            publicKeyCredential = await webauthnJson.get(credentialGetOptions);            
            if(publicKeyCredential.response.userHandle === null){
              reject();
            }
            else{
               resolve(publicKeyCredential);                
            }                    
          }catch(e){
            if(publicKeyCredential === undefined) {
              reject('cancel');
            }
            else{
              reject();
            }            
          }
        }
      },
      error: function () {
        reject();
      }
    });		
  });
}

// Passkey demo async functions - end
